import axios from "axios";
import url from "@/utils/api/url";

const URL_USER = url.URL_API + '/user';

// 与人员信息相关的URL
const URL_USER_PERSON = URL_USER + '/person';
const URL_USER_PERSON_IMPORT = URL_USER + '/person/import';
const URL_USER_PERSON_BASIC = URL_USER + '/person/basic';
const URL_USER_PERSON_CONTACT = URL_USER + '/person/contact';
const URL_USER_PERSON_WORK = URL_USER + '/person/work';
const URL_USER_PERSON_PICTURE = URL_USER + '/person/picture';
const URL_USER_PERSON_DESCRIPTION = URL_USER + '/person/description';
const URL_USER_PERSON_BASIC_DELETE = URL_USER+'/person/basic';

// 与管理员用户相关的URL
const URL_USER_ADMIN_INFO = URL_USER + '/admin/info';
const URL_USER_ADMIN_INFO_STATE = URL_USER + '/admin/info/state';

// 与培训基地用户相关的URL
const URL_USER_ORGAN_INFO = URL_USER + '/organ/info';
const URL_USER_ORGAN_INFO_STATE = URL_USER + '/organ/info/state';
const URL_USER_ORGAN_INFO_IMPORT = URL_USER + '/organ/info/import';
const URL_USER_ORGAN_COURSE = URL_USER + '/organ/course';
const URL_USER_ORGAN_COURSE_IMPORT = URL_USER + '/organ/course/import';
const URL_USER_ORGAN_SEAL = URL_USER + '/organ/seal';
const URL_USER_ORGAN_COURSE_DELETE = URL_USER+'/organ/course';

// 与职业院校用户相关的URL
const URL_USER_COLLEGE_INFO = URL_USER + '/college/info';
const URL_USER_COLLEGE_INFO_STATE = URL_USER + '/college/info/state';
const URL_USER_COLLEGE_INFO_IMPORT = URL_USER + '/college/info/import';
const URL_USER_ALL_COLLEGE_INFO = URL_USER +'/college/all/info';

// 与参训教师用户相关的URL
const URL_USER_STUDENT_INFO = URL_USER + '/student/info';
const URL_USER_STUDENT_INFO_STATE = URL_USER + '/student/info/state';
const URL_USER_STUDENT_INFO_CHECK = URL_USER + '/student/info/check';
const URL_USER_STUDENT_INFO_IMPORT = URL_USER + '/student/info/import';
const URL_USER_STUDENT_COURSE = URL_USER + '/student/course';
const URL_USER_STUDENT_BASIC_INFO = URL_USER + '/student/synthesize/info';
const URL_USER_STUDENT_INFO_DELETE = URL_USER + '/student/delete';

// 与评审专家用户相关的URL
const URL_USER_EXPERT_INFO = URL_USER + '/expert/info';
const URL_USER_EXPERT_INFO_STATE = URL_USER + '/expert/info/state';
const URL_USER_EXPERT_INFO_IMPORT = URL_USER + '/expert/info/import';
const URL_USER_EXPERT_USERNAME_CHECK=URL_USER + '/expert/check';

// 与用户登录相关的URL
const URL_USER_LOGIN = URL_USER + '/login';
const URL_USER_LOGIN_PASSWORD = URL_USER + '/login/password';
const URL_USER_LOGIN_RESET = URL_USER + '/login/reset';
//----------------------------------二期修改----------------------------
//院校联系人相关
const URL_USER_COLLEGE_CONTACT = URL_USER + '/createcontact';
const URL_USER_INFORMATION_CONTACT = URL_USER + '/information';
const URL_USER_INFORMATION_BASIC_INFO = URL_USER + '/information/basic';
const URL_USER_INFORMATION_CONTACT_INFO = URL_USER + '/information/contact';
const URL_USER_INFORMATION_WORK_INFO = URL_USER + '/information/work';

//参训教师相关
const URL_STUDENT_BASIC_INFO = URL_USER + '/student/basic';
const URL_STUDENT_CONTACT_INFO = URL_USER + '/student/contact';
const URL_STUDENT_WORK_INFO = URL_USER + '/student/work';
const URL_STUDENT_PICTURE_INFO = URL_USER + '/student/picture';
const URL_USER_STUDENT_INFO_FORGET_CHECK = URL_USER + '/student/forget/check';
const URL_USER_STUDENT_UPDATE_PASSWORD = URL_USER + '/student/update/password';

//培训基地人员相关
const URL_ORGAN_DATA_PAGING = URL_USER + '/organ';
const URL_ORGAN_CREATE_CONTACT = URL_USER + '/organ/create';
const URL_ORGAN_BASIC_INFO = URL_USER + '/organ/basic';
const URL_ORGAN_CONTACT_INFO = URL_USER + '/organ/contact';
const URL_ORGAN_WORK_INFO = URL_USER + '/organ/work';
const URL_ORGAN_DESCRIPTION = URL_USER + '/organ/description'
const URL_ORGAN_PERSON_IMPORT = URL_USER + '/organ/import'

//通识类讲师相关
const URL_LECTURER_DATA_PAGING = URL_USER + '/lecturer';
const URL_LECTURER_CREATE_DEFAULT_PERSON = URL_USER + '/lecturer/create';
const URL_LECTURER_BASIC_INFO = URL_USER + '/lecturer/basic';
const URL_LECTURER_CONTACT_INFO = URL_USER + '/lecturer/contact';
const URL_LECTURER_WORK_INFO = URL_USER + '/lecturer/work';

//主管部门联系人相关
const URL_DEPARTMENT_DATA_PAGING = URL_USER + '/department';
const URL_DEPARTMENT_CREATE_DEFAULT_PERSON = URL_USER + '/department/create';
const URL_DEPARTMENT_BASIC_INFO = URL_USER + '/department/basic';
const URL_DEPARTMENT_CONTACT_INFO = URL_USER + '/department/contact';
const URL_DEPARTMENT_WORK_INFO = URL_USER + '/department/work';

//评审专家相关
const URL_EXPERT_BASIC_INFO = URL_USER + '/expert/basic';
const URL_EXPERT_CONTACT_INFO = URL_USER + '/expert/contact';
const URL_EXPERT_WORK_INFO = URL_USER + '/expert/work';


export default {
    person: {
        createDefaultPerson(info) {
            return axios.post(URL_USER_PERSON, info);
        },
        importPersonData(info) {
            return axios.get(URL_USER_PERSON_IMPORT, {params: info});
        },
        createCollegeContact(info) {
            return axios.post(URL_USER_COLLEGE_CONTACT, info);
        },
        createOrganContact(info) {
            return axios.post(URL_ORGAN_CREATE_CONTACT, info);
        },
        importOrganPersonData(info) {
            return axios.get(URL_ORGAN_PERSON_IMPORT, {params: info});
        },
        createLecturerDefaultPerson(info) {
            return axios.post(URL_LECTURER_CREATE_DEFAULT_PERSON, info);
        },
        createDepartmentDefaultPerson(info) {
            return axios.post(URL_DEPARTMENT_CREATE_DEFAULT_PERSON, info);
        },

        basic: {
            getExpertBasicInfo(expertId) {
                return axios.get(URL_EXPERT_BASIC_INFO + '/' + expertId);
            },
            updateExpertBasicInfo(info) {
                return axios.put(URL_EXPERT_BASIC_INFO + '/' + info.personId, info);
            },
            getDepartmentBasicInfo(personId) {
                return axios.get(URL_DEPARTMENT_BASIC_INFO + '/' + personId);
            },
            updateDepartmentBasicInfo(info) {
                return axios.put(URL_DEPARTMENT_BASIC_INFO + '/' + info.personId, info);
            },
            getLecturerBasicInfo(personId) {
                return axios.get(URL_LECTURER_BASIC_INFO + '/' + personId);
            },
            updateLecturerBasicInfo(info) {
                return axios.put(URL_LECTURER_BASIC_INFO + '/' + info.personId, info);
            },
            getStudentBasicInfo(info) {
                return axios.get(URL_STUDENT_BASIC_INFO + '/' + info.personId, {params: info});
            },
            updateStudentBasicInfo(info) {
                return axios.put(URL_STUDENT_BASIC_INFO + '/' + info.personId, info);
            },
            getInformationBasicInfo(personId) {
                return axios.get(URL_USER_INFORMATION_BASIC_INFO + '/' + personId);
            },
            updateInformationBasicInfo(info) {
                return axios.put(URL_USER_INFORMATION_BASIC_INFO + '/' + info.personId, info);
            },
            getOrganBasicInfo(personId) {
                return axios.get(URL_ORGAN_BASIC_INFO + '/' + personId);
            },
            updateOrganBasicInfo(info) {
                return axios.put(URL_ORGAN_BASIC_INFO + '/' + info.personId, info);
            },
            getPersonBasicDataWithPaging(filterCondition) {
                return axios.get(URL_USER_PERSON_BASIC, {params: filterCondition});
            },
            getPersonBasicInfo(info) {
                return axios.post(URL_USER_PERSON_BASIC + '/' + info.personId, info);
            },
            insertPersonBasicInfo(info) {
                return axios.post(URL_USER_PERSON_BASIC, info);
            },
            updatePersonBasicInfo(info) {
                return axios.put(URL_USER_PERSON_BASIC + '/' + info.personId, info);
            },
            deleteOrganPersonBasicInfo(personId){
                return axios.delete(URL_ORGAN_BASIC_INFO+'/'+personId);
            },
            getPersonInformationDataWithPaging(filterCondition) {
                return axios.get(URL_USER_INFORMATION_CONTACT, {params: filterCondition});
            },
            getOrganDataWithPaging(filterCondition) {
                return axios.get(URL_ORGAN_DATA_PAGING, {params: filterCondition});
            },
            getLecturerDataWithPaging(filterCondition) {
                return axios.get(URL_LECTURER_DATA_PAGING, {params: filterCondition});
            },
            getDepartmentDataWithPaging(filterCondition) {
                return axios.get(URL_DEPARTMENT_DATA_PAGING, {params: filterCondition});
            },
        },
        contact: {
            getExpertContactInfo(expertId) {
                return axios.get(URL_EXPERT_CONTACT_INFO + '/' +expertId)
            },
            updateExpertContactInfo(info) {
                return axios.put(URL_EXPERT_CONTACT_INFO + '/' +info.personId, info);
            },
            getDepartmentContactInfo(personId) {
                return axios.get(URL_DEPARTMENT_CONTACT_INFO + '/' +personId)
            },
            updateDepartmentContactInfo(info) {
                return axios.put(URL_DEPARTMENT_CONTACT_INFO + '/' +info.personId, info);
            },
            getLecturerContactInfo(personId) {
                return axios.get(URL_LECTURER_CONTACT_INFO + '/' +personId)
            },
            updateLecturerContactInfo(info) {
                return axios.put(URL_LECTURER_CONTACT_INFO + '/' +info.personId, info);
            },
            getStudentContactInfo(personId) {
                return axios.get(URL_STUDENT_CONTACT_INFO + '/' +personId)
            },
            updateStudentContactInfo(info) {
                return axios.put(URL_STUDENT_CONTACT_INFO + '/' +info.personId, info);
            },
            getInformationContactInfo(personId) {
                return axios.get(URL_USER_INFORMATION_CONTACT_INFO + '/' +personId)
            },
            updateInformationContactInfo(info) {
                return axios.put(URL_USER_INFORMATION_CONTACT_INFO + '/' +info.personId, info);
            },
            getOrganContactInfo(personId) {
                return axios.get(URL_ORGAN_CONTACT_INFO + '/' +personId)
            },
            updateOrganContactInfo(info) {
                return axios.put(URL_ORGAN_CONTACT_INFO + '/' +info.personId, info);
            },
            getPersonContactInfo(info) {
                return axios.post(URL_USER_PERSON_CONTACT + '/' + info.personId, info);
            },
            insertPersonContactInfo(info) {
                return axios.post(URL_USER_PERSON_CONTACT, info);
            },
            updatePersonContactInfo(info) {
                return axios.put(URL_USER_PERSON_CONTACT + '/' + info.personId, info);
            },
        },
        work: {
            getExpertWorkInfo(expertId) {
                return axios.get(URL_EXPERT_WORK_INFO + '/' + expertId)
            },
            updateExpertWorkInfo(info) {
                return axios.put(URL_EXPERT_WORK_INFO + '/' + info.personId, info);
            },
            getDepartmenttWorkInfo(personId) {
                return axios.get(URL_DEPARTMENT_WORK_INFO + '/' + personId)
            },
            updateDepartmentWorkInfo(info) {
                return axios.put(URL_DEPARTMENT_WORK_INFO + '/' + info.personId, info);
            },
            getLecturertWorkInfo(personId) {
                return axios.get(URL_LECTURER_WORK_INFO + '/' + personId)
            },
            updateLecturerWorkInfo(info) {
                return axios.put(URL_LECTURER_WORK_INFO + '/' + info.personId, info);
            },
            getStudentWorkInfo(personId) {
                return axios.get(URL_STUDENT_WORK_INFO + '/' + personId)
            },
            updateStudentWorkInfo(info) {
                return axios.put(URL_STUDENT_WORK_INFO + '/' + info.personId, info);
            },
            getInformationWorkInfo(personId) {
                return axios.get(URL_USER_INFORMATION_WORK_INFO + '/' + personId)
            },
            updateInformationWorkInfo(info) {
                return axios.put(URL_USER_INFORMATION_WORK_INFO + '/' + info.personId, info);
            },
            getOrganWorkInfo(personId) {
                return axios.get(URL_ORGAN_WORK_INFO + '/' + personId)
            },
            updateOrganWorkInfo(info) {
                return axios.put(URL_ORGAN_WORK_INFO + '/' + info.personId, info);
            },
            getPersonWorkInfo(info) {
                return axios.post(URL_USER_PERSON_WORK + '/' + info.personId,info);
            },
            insertPersonWorkInfo(info) {
                return axios.post(URL_USER_PERSON_WORK, info);
            },
            updatePersonWorkInfo(info) {
                return axios.put(URL_USER_PERSON_WORK + '/' + info.personId, info);
            },
        },
        picture: {
            getStudentPictureInfo(personId) {
                return axios.get(URL_STUDENT_PICTURE_INFO + '/' + personId);
            },
            updateStudentPictureInfo(info) {
                return axios.put(URL_STUDENT_PICTURE_INFO + '/' + info.personId, info);
            },
            getPersonPictureInfo(personId) {
                return axios.get(URL_USER_PERSON_PICTURE + '/' + personId);
            },
            insertPersonPictureInfo(info) {
                return axios.post(URL_USER_PERSON_PICTURE, info);
            },
            updatePersonPictureInfo(info) {
                return axios.put(URL_USER_PERSON_PICTURE + '/' + info.personId, info);
            },
        },
        description: {
            getOrganPersonDescriptionInfo(info) {
                return axios.get(URL_ORGAN_DESCRIPTION + '/' + info.personId);
            },
            insertOrganPersonDescriptionInfo(info) {
                return axios.post(URL_ORGAN_DESCRIPTION, info);
            },
            updateOrganPersonDescriptionInfo(info) {
                return axios.put(URL_ORGAN_DESCRIPTION + '/' + info.personId, info);
            },
            getPersonDescriptionInfo(info) {
                return axios.get(URL_USER_PERSON_DESCRIPTION + '/' + info.personId, info);
            },
            insertPersonDescriptionInfo(info) {
                return axios.post(URL_USER_PERSON_DESCRIPTION, info);
            },
            updatePersonDescriptionInfo(info) {
                return axios.put(URL_USER_PERSON_DESCRIPTION + '/' + info.personId, info);
            },
        },
    },

    admin: {
        getAdminUserData() {
            return axios.get(URL_USER_ADMIN_INFO);
        },
        getAdminUserInfoById(userId) {
            return axios.get(URL_USER_ADMIN_INFO + '/' + userId);
        },
        insertAdminUserInfo(info) {
            return axios.post(URL_USER_ADMIN_INFO, info);
        },
        updateAdminUserInfo(info) {
            return axios.put(URL_USER_ADMIN_INFO + '/' + info.userId, info);
        },
        updateAdminUserState(info) {
            return axios.put(URL_USER_ADMIN_INFO_STATE + '/' + info.userId, info);
        },
    },

    organ: {
        getOrganUserData(filterCondition) {
            return axios.get(URL_USER_ORGAN_INFO, {params: filterCondition});
        },
        getOrganUserInfoById(organId) {
            return axios.get(URL_USER_ORGAN_INFO + '/' + organId);
        },
        insertOrganUserInfo(info) {
            return axios.post(URL_USER_ORGAN_INFO, info);
        },
        updateOrganUserInfo(info) {
            return axios.put(URL_USER_ORGAN_INFO + '/' + info.organId, info);
        },
        updateOrganUserState(info) {
            return axios.put(URL_USER_ORGAN_INFO_STATE + '/' + info.organId, info);
        },

        importOrganData(info) {
            return axios.get(URL_USER_ORGAN_INFO_IMPORT, {params: info});
        },

        course: {
            getOrganCourseDataWithPaging(filterCondition) {
                console.info('params',filterCondition)
                return axios.get(URL_USER_ORGAN_COURSE, {params: filterCondition});
            },
            getOrganCourseInfoById(courseId) {
                return axios.get(URL_USER_ORGAN_COURSE + '/' + courseId);
            },
            insertOrganCourseInfo(info) {
                return axios.post(URL_USER_ORGAN_COURSE, info);
            },
            updateOrganCourseInfo(info) {
                return axios.put(URL_USER_ORGAN_COURSE + '/' + info.courseId, info);
            },

            importOrganCourseData(info) {
                return axios.get(URL_USER_ORGAN_COURSE_IMPORT, {params: info});
            },
            deleteOrganCourseInfo(courseId){
                return axios.delete(URL_USER_ORGAN_COURSE_DELETE+ '/' +courseId);
            }
        },
        seal: {
            getOrganSealInfo(organId) {
                return axios.get(URL_USER_ORGAN_SEAL + '/' + organId);
            },
            insertOrganSealInfo(info) {
                return axios.post(URL_USER_ORGAN_SEAL, info);
            },
            updateOrganSealInfo(info) {
                return axios.put(URL_USER_ORGAN_SEAL + '/' + info.organId, info);
            },
        }
    },

    college: {
        getCollegeUserData(filterCondition) {
            return axios.get(URL_USER_COLLEGE_INFO, {params: filterCondition});
        },
        getCollegeUserInfoById(collegeId) {
            return axios.get(URL_USER_COLLEGE_INFO + '/' + collegeId);
        },
        insertCollegeUserInfo(info) {
            return axios.post(URL_USER_COLLEGE_INFO, info);
        },
        updateCollegeUserInfo(info) {
            return axios.put(URL_USER_COLLEGE_INFO + '/' + info.collegeId, info);
        },
        updateCollegeUserState(info) {
            return axios.put(URL_USER_COLLEGE_INFO_STATE + '/' + info.collegeId, info);
        },
        getAllCollegeUserData(){
            return axios.get(URL_USER_ALL_COLLEGE_INFO);
        },

        importCollegeData(info) {
            return axios.get(URL_USER_COLLEGE_INFO_IMPORT, {params: info});
        }
    },

    student: {
        getStudentUserData(filterCondition) {
            return axios.get(URL_USER_STUDENT_INFO, {params: filterCondition});
        },
        getStudentUserInfoById(studentId) {
            return axios.get(URL_USER_STUDENT_INFO + '/' + studentId);
        },
        insertStudentUserInfo(info) {
            return axios.post(URL_USER_STUDENT_INFO, info);
        },
        updateStudentUserInfo(info) {
            return axios.put(URL_USER_STUDENT_INFO + '/' + info.studentId, info);
        },
        updateStudentUserState(info) {
            return axios.put(URL_USER_STUDENT_INFO_STATE + '/' + info.studentId, info);
        },
        updateStudentUserBasicInfo(editStudentBasicInfo){
            return axios.put(URL_USER_STUDENT_BASIC_INFO+'/'+ editStudentBasicInfo.studentId, editStudentBasicInfo);
        },

        checkStudentEmailAndMobilePhone(info) {
            return axios.get(URL_USER_STUDENT_INFO_CHECK, {params: info});
        },

        importStudentData(info) {
            return axios.get(URL_USER_STUDENT_INFO_IMPORT, {params: info});
        },
        deleteStudentUserInfo(studentId){
            return axios.delete(URL_USER_STUDENT_INFO_DELETE + '/' + studentId);
        },
        checkStudentInfo(info) {
            return axios.get(URL_USER_STUDENT_INFO_FORGET_CHECK, {params:info});
        },
        updateStudentPassword(info) {
            return axios.put(URL_USER_STUDENT_UPDATE_PASSWORD, info);
        },

        course: {
            getStudentCourseData(studentId) {
                return axios.get(URL_USER_STUDENT_COURSE, {params: {studentId}});
            },
            getStudentCourseInfoById(pkId) {
                return axios.get(URL_USER_STUDENT_COURSE + '/' + pkId);
            },
            insertStudentCourseInfo(info) {
                return axios.post(URL_USER_STUDENT_COURSE, info);
            },
            deleteStudentCourseInfoById(pkId) {
                return axios.delete(URL_USER_STUDENT_COURSE + '/' + pkId);
            },
        }
    },

    expert: {
        getExpertUserData(filterCondition) {
            return axios.get(URL_USER_EXPERT_INFO, {params: filterCondition});
        },
        getExpertUserInfoById(expertId) {
            return axios.get(URL_USER_EXPERT_INFO + '/' + expertId);
        },
        insertExpertUserInfo(info) {
            return axios.post(URL_USER_EXPERT_INFO, info);
        },
        updateExpertUserInfo(info) {
            return axios.put(URL_USER_EXPERT_INFO + '/' + info.expertId, info);
        },
        updateExpertUserState(info) {
            return axios.put(URL_USER_EXPERT_INFO_STATE + '/' + info.expertId, info);
        },

        importExpertData(info) {
            return axios.get(URL_USER_EXPERT_INFO_IMPORT, {params: info});
        },

        getExpertEnum() {
            return axios.get(URL_USER_EXPERT_INFO + '/enum');
        },
        checkUserName(info) {
            return axios.get(URL_USER_EXPERT_USERNAME_CHECK, {params: info});
        }
    },

    login: {
        userLogin(info) {
            return axios.post(URL_USER_LOGIN, info);
        },
        updateUserPassword(info) {
            return axios.put(URL_USER_LOGIN_PASSWORD + '/' + info.userId, info);
        },
        resetUserPassword(info) {
            return axios.put(URL_USER_LOGIN_RESET + '/' + info.userId, info);
        }
    }
}
